import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import Video from '@src/ds/components/molecules/Video/Video';
// import {VideoResponse} from '@src/Data/Model/Video';
// import DataSourceMain from '@src/Data/DataSource/Video';
// import HttpClient from '@Infra/Http';
import Loader from '@src/ds/components/atoms/Loader';
import {PageLoader} from '@src/ds/components/atoms/Loader/Loader.styl';

const Embed = () => {
  const {id} = useParams();

  const [data, setData] = useState<{
    primaryColor: string;
    transcription: string;
    subtitles: {
      label: string;
      src: string;
      language: string;
    }[];
    config: {
      autoplay: boolean;
      fullScreen: boolean;
      muted: boolean;
      responsive: boolean;
      preload: boolean;
      loop: boolean;
      pip: boolean;
      controls: boolean;
      originalAspectRatio: boolean;
    };
    aspectRatio: string;
    poster: string;
    video: string;
    token: string;
    cdnKey: string;
    summaryVideo: string;
    summaryVideoCdnKey: string;
    authorization: string;
    waterMark: string;
    ai: string;
  } | null>(null);
  // const [token, setToken] = useState<string>('');
  // const [poster, setPoster] = useState<string>('');
  // const [source, setSource] = useState<string | undefined>('');
  const hasServiceWorker = 'serviceWorker' in navigator;
  const [worker, setWorker] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  // const httpClient = new HttpClient();
  // const dataSource = new DataSourceMain(httpClient);

  async function getSource() {
    const rootParams = document.querySelector('.smartplayer-component.smartplayer--iframe') as HTMLDivElement;
    const dataAttr = rootParams.getAttribute('data');
    const worker = rootParams.getAttribute('data-worker');
    // const ssrVideo = rootParams.getAttribute('data-video');
    // const posterVideo = rootParams.getAttribute('data-poster');
    // const tokenVideo = rootParams.getAttribute('data-id');

    console.log('worker', worker, 'hasServiceWorker', hasServiceWorker);

    setWorker(worker === '1');

    if (dataAttr && dataAttr !== '[DATA]') {
      setData(JSON.parse(dataAttr.split("'").join('"') || ''));
      // setIsLoading(false);
      // return null;
    }

    if (dataAttr
    && dataAttr !== '[DATA]'
    && hasServiceWorker
    && worker === '1') {
      setIsLoading(false);
    }

    if (!hasServiceWorker || worker === '0') {
      setIsLoading(false);
    }

    // const referrer = document?.referrer ? new URL(document?.referrer) : null;

    // const response: VideoResponse = await dataSource.getMedia({
    //   mediaCode: id,
    //   code: referrer?.origin ? window.btoa(referrer?.origin) : window.btoa('https://player.scaleup.com.br'),
    // });

    // setPoster(response.success ? (response?.poster || '') : '');
    // setSource(response.success ? response?.video : '');
    // setIsLoading(false);

    // return null;
  }

  useEffect(() => {
    if (!hasServiceWorker) {
      return;
    }

    const root = document.querySelector('.smartplayer-component.smartplayer--iframe') as HTMLDivElement;

    console.log('is event reader');

    root.addEventListener('worker', () => {
      console.log('is worker loader');
      getSource();
    });
  }, []);

  useEffect(() => {
    if (hasServiceWorker && navigator.serviceWorker?.controller?.state === 'activated') {
      getSource();
    } else if (!hasServiceWorker) {
      getSource();
    } else if (worker === null) {
      getSource();
    }
  }, [worker, hasServiceWorker]);

  if (isLoading) {
    return (
      <PageLoader className="page-loader--studio">
        <Loader model="inline" variant="blue" />
      </PageLoader>
    );
  }

  return (
    <Video
      id={`embed-player--${id || ''}`}
      primaryColor={data?.primaryColor || ''}
      transcription={data?.transcription || ''}
      subtitles={data?.subtitles || []}
      config={data?.config || {
        autoplay: false,
        fullScreen: false,
        muted: false,
        responsive: true,
        preload: true,
        loop: false,
        pip: true,
        controls: true,
        originalAspectRatio: false,
      }}
      aspectRatio={data?.aspectRatio || '16:9'}
      src={data?.video || ''}
      poster={data?.poster || ''}
      token={data?.token || ''}
      cdnKey={data?.cdnKey || ''}
      summaryVideo={data?.summaryVideo || ''}
      summaryVideoCdnKey={data?.summaryVideoCdnKey || ''}
      mediaCode={id || ''}
      ai={(data?.ai || '')}
      hasSearch={(data?.ai || '').indexOf('SMART_SEARCH') > -1}
      waterMark={data?.waterMark}
      authorization={data?.authorization || ''}
    />
  );
};

export default Embed;
